import Vue from 'vue';

const debounce = function (func, wait, immediate = true) {
    let timeout;
    return function () {
        if (timeout) clearTimeout(timeout);
        if (immediate) {
            let callNow = !timeout;
            timeout = setTimeout(() => {
                timeout = null;
            }, wait);
            if (callNow) func.apply(this, arguments);
        } else {
            timeout = setTimeout(function () {
                func.apply(this, arguments);
            }, wait);
        }
    };
};

Vue.directive("debounce", {
    bind(el, binding,) {
        const func = debounce(binding.value, 1000);
        el.addEventListener('click', func);
    }
})